import { ConfigProvider } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User, UserType } from 'api/models';
import { MembersMeta, Project } from 'api/project';
import { Table } from 'components/molecules/table';
import { useUser } from 'hooks/use-user';
import { Membership, Memberships } from 'stores/memberships';
import { columnsList } from './columns';

const EmptyContainer = styled.div`
  color: var(--gray-50);
  padding: var(--spacing-05);
`;

export const TeamTable: FC<{
  project: Project;
  data: User[];
  memberships: Memberships;
  loggedInUserPermissions: Membership | undefined;
  membersMeta: MembersMeta | undefined;
  isLoading?: boolean;
  usersType: UserType;
}> = ({
  project,
  data,
  memberships,
  loggedInUserPermissions,
  membersMeta,
  isLoading = false,
  usersType,
}) => {
  const loggedInUser = useUser();

  const columns = columnsList({
    project,
    loggedInUserPermissions,
    membersMeta,
    loggedInUser,
    memberships,
  });

  return (
    <ConfigProvider
      renderEmpty={() => (
        <EmptyContainer>
          <FormattedMessage
            id={`project.invitation.empty_table.${usersType.toLowerCase()}`}
          />
        </EmptyContainer>
      )}
    >
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        size="small"
        loading={isLoading}
      />
    </ConfigProvider>
  );
};
